<template lang="pug">
    svg.svg-icon(v-if="type === 'svg'")
      use(:xlink:href="`#${iconClass}`")
        animateTransform(v-if="animate" attributeType="xml" attributeName="transform" type="rotate" 
        :from="animateRangeEnd" :to="animateRangeFrom" dur="0.8s" repeatCount="indefinite")
    div.pngIcon.inline-block(:class="iconClass" v-else)
</template>
<script>
export default {
  name: 'PicIcon',
  props: {
    iconClass: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'svg'
    },
    className: {
      type: String,
      default: ''
    },
    animate:{
      type:Boolean,
      default:false,
    },
    animateHeightCircle:{ //要原地旋轉的話要給圖片高度一半
      type: Number,
      default: 40,
      required: false
    }
  },
  data() {
    return {
    };
  },
  created(){
  },
  computed: {
    animateRangeEnd(){
        return `0 ${this.animateHeightCircle} ${this.animateHeightCircle}`
    },
    animateRangeFrom () {
        return `360 ${this.animateHeightCircle} ${this.animateHeightCircle}`
    },
    // iconName () {
    //   return this.iconClass;
    // },
    // svgClass () {
    //   if (this.className) {
    //     return 'svg-icon ' + this.className
    //   } else {
    //     return 'svg-icon'
    //   }
    // }
    
  },
  watch:{
  },
}
</script>
<style lang="scss" scoped>

.svg-icon {
  fill: currentColor;
  overflow: hidden;
}

</style>
